// extracted by mini-css-extract-plugin
module.exports = {"container":"Gy-z","recos":"Hy-z","productCardOverride":"Iy-z"};